import React, { useState } from 'react'
import SubHeader from '../general/SubHeader'
import ContactImg from '../assets/contact-left.jpg';
import axios from 'axios';
import Loading from '../general/Loading';


const Contact = () => {
      const [responseMessage, setResponseMessage] = useState('');
      const [loading, setLoading] = useState(false);
 const [formData, setFormData] = useState({
  name: '',
  mobile: '',
  email: '',
  message: ''
 })

     // Handle form field changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        setResponseMessage('');
        setLoading(true);

        try {
            const response = await axios.post('https://api.shaktitours.com/contact', formData);

                      setLoading(false);
            if (response.status === 200) {
                setFormData({
  name: '',
  mobile: '',
  email: '',
  message: ''
 })

                setResponseMessage('Thank you for getting in touch! We will respond you soon.');

                setTimeout(() => {
                    setResponseMessage('');
                }, 3000);
            }
        } catch (error) {
            // Handle error response
                      setLoading(false);
            setResponseMessage('Error submitting form. Please try again later.');
            setTimeout(() => {
                setResponseMessage('');
            }, 3000);
        }
    };

  return (
    <>
            <SubHeader message='Contact' />

{/* contact section */}
<section className='py-5'>
    <div className='container text-center'>

              <p className='sec-subheading my-0'>Contact Info</p>
          <p className='sec-heading'>Our Contact Information</p>

<div className='row'>

<div className='col-lg-4 col-md-6 col-12 my-2'>
    <div className='contact-area'>
        <i class="fa-solid contact-icon fa-location-dot"></i>
                <p className='benefit-text mt-2'>Our Location</p>
<p className='text-muted para-text'>Shivam paints, Myohol Rd, Manmohan Park Rd, near shivam paints, Old Katra, Prayagraj, Uttar Pradesh 211002</p>
    </div>
</div>

<div className='col-lg-4 col-md-6 col-12 my-2'>
    <div className='contact-area'>
        <i class="fa-solid contact-icon fa-phone"></i>
                <p className='benefit-text'><br />Phone Number</p>
<p className='text-muted'>969 588 9735</p>
    </div>
</div>

<div className='col-lg-4 col-md-6 col-12 my-2'>
    <div className='contact-area'>
        <i class="fa-solid contact-icon fa-envelope"></i>
                <p className='benefit-text'><br />Our Email</p>
<p className='text-muted'>Shaktitours01@gmail.com</p>
    </div>
</div>



</div>
{/* row ends */}

    </div>
</section>
{/* contact section ends */}


{/* form section */}
<section>
    <div className='row'>

<div className='col-lg-6 col-12 px-0'>
<img src={ContactImg} className='img-fluid' />
</div>

<div className='col-lg-6 col-12 contact-right px-5 align-content-center'>
    
              <p className='sec-subheading my-0 text-white'>Get in Touch</p>
          <p className='sec-heading'>Send us A message</p>

<form class="row g-3" onSubmit={handleSubmit}>
  <div class="col-12">
    <input type="text" class="contact-control" id="inputText4" placeholder='Name' value={formData.name} onChange={handleChange} name='name' required />
  </div>
  <div class="col-md-6">
    <input type="tel" class="contact-control" id="inputText4" placeholder='Mobile' value={formData.mobile} onChange={handleChange} name='mobile' pattern="[0-9]*" maxLength={10} required />
  </div>
  <div class="col-md-6">
    <input type="email" class="contact-control" id="inputEmail4" placeholder='Email' value={formData.email} onChange={handleChange} name='email' required />
  </div>
  <div class="col-12">
    <input type="text" class="contact-control" id="inputText4" style={{height: '6em'}} value={formData.message} onChange={handleChange} name='message' placeholder='Message' required />
  </div>

  <div class="col-12 mt-4">
    <button type="submit" class="nav-btn bg-black">Submit Now</button>
  </div>
</form>

</div>

    </div>
    {/* row ends */}
</section>
{/* form section ends */}


{/* map section */}
<section className='my-5'>
    <div className='container'>

<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2547.18578012699!2d81.84660616040117!3d25.46283610185081!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399acb17223bff9d%3A0xd1dc20eda92b7861!2sOmanshi%20travels!5e0!3m2!1sen!2sin!4v1764650296375!5m2!1sen!2sin"
className='w-100' height="550" style={{border:0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
    </div>
</section>
{/* map section ends */}

            {responseMessage && (
                <div className="response-message d-flex justify-content-between">
                    <p className='my-0 mx-auto'>{responseMessage}</p>
                    <p className='my-0 cursor-pointer' onClick={() => setResponseMessage(false)}> &nbsp;<i class="fa-solid fa-xmark"></i></p>
                </div>)}

{loading && <Loading setLoading={setLoading} />}
    </>
  )
}

export default Contact
